const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    spacer: {
        padding: "10px",
    },
    equationContainer: {
        marginTop: "10px",
        padding: "10px",
        backgroundSize: "4px 4px",
        backgroundImage: "linear-gradient(to right, #f0f0f0 1px, transparent 1px), linear-gradient(to bottom, #f0f0f0 1px, transparent 1px)"
    }
});

export default styles;